import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import Notify from '@/components/Notification';
import { QUERY_KEYS } from '@/query/queryKeys';
import { fundraisingService } from '../../services/fundraisingService';

export const useLenderSetFundraising = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  return useMutation({
    mutationFn: async payload => {
      const response = await fundraisingService.lenderSetFundraising(payload);
      const { status, data } = response;

      if (status === 200) {
        queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.fundraising.lender_applications] });
        queryClient.setQueryData(
          [QUERY_KEYS.fundraising.lender_fr_status_by_company_id, payload.company_id],
          () => data,
        );
        Notify.success({ text: t('fundraising:shared.fundraising_goal_successfully_set') });
        return data;
      }

      if (status === 400) {
        Notify.error({ text: data.message });
      }

      return null;
    },
  });
};
